export default "__VITE_ASSET__Bh9DYzat__"